module.exports = __webpack_public_path__ + "img/sms-sned.efad82e0.svg";